import { hcupload, post, jsonpost,get } from "../baseConfig/http";
import apiConfig from "../baseConfig/apiConfig";

export const userlogin = (url, params) => jsonpost(apiConfig.userApi.login + url, params);
export const resetPassword = ( params) => get(apiConfig.userApi.resetPassword, params);
export const phonelogin = (url, params) => jsonpost(apiConfig.userApi.phonelogin + url, params);
export const loginout = ( params) => get(apiConfig.userApi.loginout, params);
export const getusermsg = ( params) => get(apiConfig.userApi.usermsg, params);
export const usermsgread = (params) => jsonpost(apiConfig.userApi.usermsgread, params);
export const updateuserpwd = (params) => jsonpost(apiConfig.userApi.userpwd, params);
export const userregister = (url, params) => jsonpost(apiConfig.userApi.register + url, params);

export const getuserinfo = (params) => post(apiConfig.userApi.userinfo, params);
export const getpersoninfo = (params) => post(apiConfig.userApi.personinfo, params);
export const updateperson = (params) => jsonpost(apiConfig.userApi.updateperson, params);

export const getAddressList = (params) => jsonpost(apiConfig.userApi.getaddress, params);
export const addAddress = (params) => jsonpost(apiConfig.userApi.addaddress, params);
export const updateAddress = (params) => jsonpost(apiConfig.userApi.updateaddress, params);

export const getbookcate = (params) => post(apiConfig.userApi.bookcate, params);
export const getbooklists = (params) => post(apiConfig.userApi.booklists, params);
export const getbookdetail = (params) => post(apiConfig.userApi.bookdetail, params);
//上传文件
export const beforfileup = (params) => post(apiConfig.commonApi.bfileup, params);

export const uploadSignApi = (params) => hcupload(apiConfig.commonApi.fileup, params);

export const downloadResource = apiConfig.commonApi.downfile;

// 购物车
export const getCartList = (params) => jsonpost(apiConfig.cartApi.getCartList, params);
export const addCart = (params) => jsonpost(apiConfig.cartApi.addCart, params);
export const delCart = (url, params) => jsonpost(apiConfig.cartApi.delCart + url, params);
export const updateCart = (params) => jsonpost(apiConfig.cartApi.updateCart, params);
export const clearCart = (params) => jsonpost(apiConfig.cartApi.clearCart, params);

// 我的订单
export const getOrderList = (params) => get(apiConfig.orderApi.getOrderList, params);
export const addOrder = (params) => jsonpost(apiConfig.orderApi.addOrder, params);
export const getPayOrderDetail = (url,params) => get(apiConfig.orderApi.getPayOrderDetail+url, params);
export const getPayOrderCheck = (params) => get(apiConfig.orderApi.getPayOrderCheck, params);
// 取消订单
export const cancelOrder = (params) => get(apiConfig.orderApi.cancelOrder, params);

// 货物签收
export const signOrder = (params) => jsonpost(apiConfig.orderApi.signOrder, params);

// 发送验证码
export const sendSmsCode = (params) => get(apiConfig.userApi.sendSmsCode, params);

// 获取文章
export const getArticle = (params) => get(apiConfig.userApi.getArticle, params);
export const getArticleDetail = (params) => get(apiConfig.userApi.getArticledetail, params);



// WEBPACK FOOTER //
// ./src/request/api/index.js